export const LinkArrowIcon = () => (
  <svg
    aria-hidden="true"
    className="nav-card-arrow"
    fill="none"
    viewBox="0 0 20 20"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      fill="var(--color-brand-primary-next)"
      height="19.2391"
      rx="9.61957"
      width="19.2391"
    />
    <path
      d="M8.28223 6.12598L11.6412 9.48487L8.28223 12.8438"
      stroke="var(--color-text-inverse-next)"
      strokeLinecap="round"
      strokeWidth="1.14258"
    />
  </svg>
)
